import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/sleek";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
      <div className="text-xs tracking-[0.3em] uppercase text-zinc-500">Journal · Design Tips</div>
      <h1 className="font-display text-5xl md:text-7xl font-light tracking-tight mt-4 max-w-5xl leading-[1.0]">
        Notes from the field.
      </h1>

      <div className="grid md:grid-cols-2 gap-10 mt-16">
        {posts.map((p, i) => (
          <Link to={`/blog/${p.slug}`} key={p.slug} className="group block" data-testid={`blog-card-${i}`}>
            <div className="overflow-hidden aspect-[5/4]">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
            </div>
            <div className="mt-5">
              <div className="text-[10px] tracking-[0.25em] uppercase text-zinc-500">{p.tags.join(" · ")} · {p.date}</div>
              <div className="font-display text-2xl md:text-3xl mt-2 group-hover:underline">{p.title}</div>
              <p className="text-zinc-600 mt-3 leading-relaxed">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
